<ng-container
  *ngIf="ctx.isAccessTypeParticular && !(menu.processActive | async)"
>
  <div class="main-toolbar-outer">
    <div class="main-toolbar ion-color ion-color-dark tablet-web-footer">
      <div class="footer-title"></div>
      <ion-buttons mode="md" slot="end" [ngClass]="isRgpduePolicyEnabled ? 'right-buttons-rgpdue': 'right-buttons'" >
        <ion-button class="auto-margin" (click)="navTo('misc/contacts')">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.PARTICULAR.INFORMATION_PHONE_NUMBERS' | translate }}
          </div>
        </ion-button>
        <ion-button class="auto-margin" (click)="navTo('locator')">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.PARTICULAR.SERVICES_LOCATOR' | translate }}
          </div>
        </ion-button>
        <ion-button
          (click)="
            navTo('operations/rgpdue-policy', {
              type: 'generic',
              onlyShowText: true
            })
          "
          class="auto-margin"
        >
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.PARTICULAR.PRIVACY_POLICY' | translate }}
          </div>
        </ion-button>
        <ion-button (click)="openCookiesPolicy()" *ngIf="isRgpduePolicyEnabled" class="auto-margin">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.PARTICULAR.COOKIES_POLICY' | translate }}
          </div>
        </ion-button>
        <ion-button class="auto-margin" *ngIf="isRgpduePolicyEnabled" (click)="openLegalWarning()">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.PARTICULAR.LEGAL_WARNING' | translate }}
          </div>
        </ion-button>
        <ion-button onclick="OneTrust.ToggleInfoDisplay()" class="auto-margin">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.PARTICULAR.COOKIE_SETTINGS' | translate }}
          </div>
        </ion-button>
        <div class="auto-margin">|</div>
        <ion-button class="last-button auto-margin" (click)="openTeCuidamos()">
          <img src="assets/images/te-cuidamos.svg" />
        </ion-button>
      </ion-buttons>
    </div>
  </div>

  <div class="main-toolbar-outer">
    <div
      *ngIf="mobileWeb"
      class="main-toolbar ion-color ion-color-dark mobile-footer"
      [ngClass]="{ 'slider-padding': hasBottomSlider }"
    >
      <div class="first-row">
        <div class="footer-title"></div>
        <ion-buttons slot="end" class="right-buttons">
          <ion-button (click)="openTeCuidamos()">
            <img src="assets/images/te-cuidamos.svg" />
          </ion-button>
        </ion-buttons>
      </div>
      <div>
        <ion-buttons
          mode="md"
          class="ion-justify-content-center df ai-e"
          style="flex-direction: column"
        >
          <ion-button (click)="navTo('misc/contacts')">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{
                'CORE.FOOTER.PARTICULAR.INFORMATION_PHONE_NUMBERS' | translate
              }}
            </div>
          </ion-button>
          <ion-button (click)="navTo('locator')">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.PARTICULAR.SERVICES_LOCATOR' | translate }}
            </div>
          </ion-button>
          <ion-button
            (click)="
              navTo('operations/rgpdue-policy', {
                type: 'generic',
                onlyShowText: true
              })
            "
          >
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.PARTICULAR.PRIVACY_POLICY' | translate }}
            </div>
          </ion-button>
          <ion-button *ngIf="isRgpduePolicyEnabled" (click)="openCookiesPolicy()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.PARTICULAR.COOKIES_POLICY' | translate }}
            </div>
          </ion-button>
          <ion-button *ngIf="isRgpduePolicyEnabled" (click)="openLegalWarning()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.PARTICULAR.LEGAL_WARNING' | translate }}
            </div>
          </ion-button>
          <ion-button onclick="OneTrust.ToggleInfoDisplay()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.PARTICULAR.COOKIE_SETTINGS' | translate }}
            </div>
          </ion-button>
        </ion-buttons>
      </div>
    </div>
  </div>
</ng-container>

<ng-container
 *ngIf="ctx.isAccessTypeBusiness && !(menu.processActive | async)"
>
  <div class="main-toolbar-outer">
    <div class="main-toolbar ion-color ion-color-dark tablet-web-footer">
      <div class="footer-title"></div>
      <ion-buttons mode="md" slot="end" class="right-buttons">
        <ion-button
          class="auto-margin"
          (click)="navTo('locator/services-view')"
        >
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.BUSINESS.OFFICES' | translate }}
          </div>
        </ion-button>
        <ion-button class="auto-margin" (click)="navToContactForm()">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.BUSINESS.CONTACT' | translate }}
          </div>
        </ion-button>
        <ion-button (click)="openPrivacyPolicyBusiness()" class="auto-margin">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.BUSINESS.PRIVACY_POLICY' | translate }}
          </div>
        </ion-button>
        <ion-button (click)="openCookiesPolicyBusiness()" class="auto-margin">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.BUSINESS.COOKIES_POLICY' | translate }}
          </div>
        </ion-button>
        <ion-button onclick="OneTrust.ToggleInfoDisplay()" class="auto-margin">
          <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
            {{ 'CORE.FOOTER.BUSINESS.COOKIE_SETTINGS' | translate }}
          </div>
        </ion-button>
        <div class="auto-margin">|</div>
        <ion-button
          class="last-button auto-margin"
          (click)="openTeCuidamosBusiness()"
        >
          <img src="assets/images/te-cuidamos.svg" />
        </ion-button>
      </ion-buttons>
    </div>
  </div>

  <div class="main-toolbar-outer">
    <div
      *ngIf="mobileWeb"
      class="main-toolbar ion-color ion-color-dark mobile-footer"
      [ngClass]="{ 'slider-padding': hasBottomSlider }"
    >
      <div class="first-row">
        <div class="footer-title"></div>
        <ion-buttons slot="end" class="right-buttons">
          <ion-button (click)="openTeCuidamosBusiness()">
            <img src="assets/images/te-cuidamos.svg" />
          </ion-button>
        </ion-buttons>
      </div>
      <div>
        <ion-buttons
          mode="md"
          class="ion-justify-content-center df ai-e"
          style="flex-direction: column"
        >
          <ion-button (click)="navTo('locator/services-view')">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.BUSINESS.OFFICES' | translate }}
            </div>
          </ion-button>
          <ion-button (click)="navToContactForm()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.BUSINESS.CONTACT' | translate }}
            </div>
          </ion-button>
          <ion-button (click)="openPrivacyPolicyBusiness()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.BUSINESS.PRIVACY_POLICY' | translate }}
            </div>
          </ion-button>
          <ion-button (click)="openCookiesPolicyBusiness()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.BUSINESS.COOKIES_POLICY' | translate }}
            </div>
          </ion-button>
          <ion-button onclick="OneTrust.ToggleInfoDisplay()">
            <div class="button-text mapfre-fs-xxs mapfre-fw-400 white">
              {{ 'CORE.FOOTER.BUSINESS.COOKIE_SETTINGS' | translate }}
            </div>
          </ion-button>
        </ion-buttons>
      </div>
    </div>
  </div>
</ng-container>